import styled from '@emotion/styled';
import { Fonts, mediaQuery } from '@styles/index';
import Image from 'next/image';

const PointText = styled.p`
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.LARGE};
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--color-text-primary);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    line-height: 18px;
  }
`;
const PointIcon = styled(Image)`
  width: 24px;
  height: 24px;
  ${mediaQuery.uptoMobile} {
    width: 20px;
    height: 20px;
  }
`;
const SubPoints = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 24px;
  margin-top: 12px;
  ${mediaQuery.uptoMobile} {
    margin-top: 16px;
  }
`;
const SubPointsDataPoint = styled.div`
  display: flex;
  gap: 5.83px;
  margin-top: 2.92px;
  margin-bottom: 2.92px;
`;

const SubPointers = ({ data, isLoggedIn }) => {
  return (
    <SubPoints>
      {(isLoggedIn ? data?.subpointsLoggedin : data?.subPointsNotLoggedIn)?.map(
        (item, index) => (
          <SubPointsDataPoint key={index}>
            <PointIcon
              width={24}
              height={24}
              src={item?.icon?.url}
              alt="icon"
            />
            <PointText>{item?.text}</PointText>
          </SubPointsDataPoint>
        )
      )}
    </SubPoints>
  );
};

export default SubPointers;
